module.exports = __webpack_public_path__ + "static/media/infoJumbo1.12829c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/steidle/images/infoJumbo1.jpg
// module id = 560
// module chunks = 0